var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"slide-canvas"},[_c('BackgroundImage',{attrs:{"image-src":_vm.image}}),_c('Confetti',{ref:"confetti"}),_c('div',{ref:"overlay",staticClass:"overlay",class:[(_vm.color + "-background")]})],1)}
var staticRenderFns = []

export { render, staticRenderFns }